'use strict';

var Params = function Params(containerWidth, containerHeight) {
  var padding = {
    top: 20,
    bottom: 30,
    left: 0,
    right: 0
  };
  var width = containerWidth - (padding.left + padding.right);
  var height = containerHeight - (padding.top + padding.bottom);
  return {
    width: width,
    height: height,
    containerWidth: containerWidth,
    containerHeight: containerHeight,
    padding: padding,
    yNumberOfTicks: 10,
    yAxisShift: 12,
    yAxisLabelShift: 55,
    xNumberOfTicks: 16,
    forceWidth: true
  };
};
module.exports = Params;